import { Grid, makeStyles, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import { Formik } from "formik";
import Cookies from "universal-cookie/lib";
import { useTheme } from "@material-ui/core/styles";

import RoundButton from "../../../../../common/button/RoundButton";
import { TextareaAutosize } from "@mui/base";
import Select from "react-select";
import {
  getApiService,
  postApiService,
} from "../../../../../../services/AgapeAPI";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useRouter } from "next/router";
import Image from "next/image";
import requerd from "../../../../../../public/assets/images/requerd.svg";

const useStyles = makeStyles((theme) => ({
  err: {
    display: "flex",
    width: "100%",
    justifyContent: "right",
    fontSize: "1.4rem",
    fontFamily: "vazir-bold",
    color: "red",
  },

  labelStyle: {
    textAlign: "left",
    fontWeight: "bold",
    fontFamily: "vazir-bold",
    marginBottom: "3px",
  },

  inputStyle: {
    background: "white",
    border: "1px solid #B6B3B3",
    borderRadius: "5px",
    outline: "none",
    padding: "10px",
    boxSizing: "border-box",
    textAlign: "left",
    direction: "rtl",
    "&::placeholder": {
      fontSize: "12px",
      fontFamily: "vazir",
    },
  },
  width380: {
    width: "261px",
    "@media only screen and (max-width: 600px)": {
      width: "320px",
    },
  },
  width222: {
    width: "222px",
    "@media only screen and (max-width: 600px)": {
      width: "330px",
    },
  },
  width92: {
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      width: "320px",
    },
  },

  errorStyle: {
    color: "red",
    fontSize: "12px",
    display: "flex",
    justifyContent: "start",
  },

  disabledsubmitButton: {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
    display: "flex",
    justifyContent: "center",
    border: "none",
    width: "280px",
    marginTop: "13px",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      width: "86%",
    },
  },
  formStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "30px",
  },

  gridContainerStyle: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
    width: "100%",
    maxWidth: "600px",
  },

  gridItemStyle: {
    display: "flex",
    flexDirection: "column",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
      justifyContent: "center",
    },
  },

  gridFullWidthItemStyle: {
    display: "flex",
    flexDirection: "column",
    gridColumn: "span 2",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
      justifyContent: "center",
    },
  },
  root: {
    borderRadius: "5px",
    color: "#acacac",
    border: "2px solid #ededed",
    // margin: "auto",
    borderRadius: "15px",
    alignSelf: "center",
    width: "222px",

    height: "40px",

    "& .MuiInputBase-root": {
      dir: "ltr",
      height: "58px",
      width: "100%",
      margin: "auto",
    },
    "& .MuiOutlinedInput-input": {},
    "@media only screen and (max-width: 600px)": {
      width: "95%",
      marginTop: "10px",
    },
  },
  submit: {
    display: "flex",
    justifyContent: "center",
    width: "280px",
    marginTop: "13px",
    alignItems: "center",
    "@media only screen and (max-width: 600px)": {
      width: "86%",
    },
  },
}));
const schema = Yup.object().shape({
  hash_id: Yup.string().required("پر کردن این فیلد اجباریست"),
  unit_count: Yup.string().required("پر کردن این فیلد اجباریست"),
  crypto_unit_id: Yup.string().required("پر کردن این فیلد اجباریست"),
  description: Yup.string()
    .required("پر کردن این فیلد اجباریست")
    .max(160, 'حد اکثر کارکتر مجاز "160" کارکتر میباشد'),
});
const PaymentForm = () => {
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [option, setOption] = useState();
  const router = useRouter();
  const cookies = new Cookies();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isLogin = cookies.get("isLoggedIn") === "1";

  const getCrypto = () => {
    getApiService("crypto/units").then((res) => {
      setOption(
        res.data.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      );
    });
  };

  useEffect(() => {
    getCrypto();
  }, []);
  return (
    <>
      <Formik
        initialValues={{
          description: "",
          unit_count: "",
          hash_id: "",
          crypto_unit_id: "",
        }}
        validationSchema={schema}
        onSubmit={(values) => {
          if (isLogin) {
            const d = {
              unit_count: values.unit_count,
              hash_id: values.hash_id,
              crypto_unit_id: values.crypto_unit_id,
              description: values.description,
              type: "organization",
            };

            postApiService(
              `crypto/organizations/${router.query.id}/paymnet`,
              d
            ).then(() => {
              toast.success("حمایت شما با موفقیت ثبت شد");
              // setOpenDialog(true);
            });
          } else {
            localStorage.setItem(
              "payment_methods_data",
              JSON.stringify({
                unit_count: values.unit_count,
                hash_id: values.hash_id,
                crypto_unit_id: values.crypto_unit_id,
                description: values.description,
              })
            );
            router.replace(`/login?from=${router.asPath}`);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className={classes.formStyle}>
            <Grid container spacing={2}>
              <Grid item md={3} xs={12}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="hash_id"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    Transaction ID
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                  </label>
                  <input
                    type="text"
                    name="hash_id"
                    placeholder="خود را وارد کنید Transaction ID"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.hash_id}
                    className={clsx(classes.inputStyle, classes.width380)}
                  />
                  {errors.hash_id && touched.hash_id && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.hash_id}
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item md={3} xs={12}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="crypto_unit_id"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    نوع رمز ارز
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                  </label>
                  <Select
                    name="crypto_unit_id"
                    placeholder="انتخاب کنید"
                    noOptionsMessage={() => "موردی یافت نشد"}
                    defaultValue={values.crypto_unit_id}
                    onChange={(selectedOption) =>
                      setFieldValue(
                        "crypto_unit_id",
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    options={option}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background: "white",
                        border: "1px solid #B6B3B3",
                        borderRadius: "5px",
                        outline: "none",
                        // padding: "10px",
                        boxSizing: "border-box",
                        textAlign: "left",
                        direction: "rtl",
                        boxShadow: "none",
                        width: isMobile ? "320px" : "261px",
                      }),
                      menu: (base) => ({
                        ...base,
                        width: isMobile ? "320px" : "261px",
                      }),
                      menuList: (base) => ({
                        ...base,
                        width: isMobile ? "320px" : "261px",
                      }),
                    }}
                  />
                  {errors.crypto_unit_id && touched.crypto_unit_id && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.crypto_unit_id}
                    </div>
                  )}{" "}
                </div>
              </Grid>
              <Grid item md={3} xs={12}>
                <div className={classes.gridItemStyle}>
                  <label
                    htmlFor="unit_count"
                    className={clsx(classes.labelStyle, classes.width380)}
                  >
                    تعداد واحد رمز ارز پرداختی
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                  </label>
                  <input
                    type="text"
                    name="unit_count"
                    placeholder="مثال:۰.۰۱"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.unit_count}
                    className={clsx(classes.inputStyle, classes.width380)}
                  />
                  {errors.unit_count && touched.unit_count && (
                    <div className={clsx(classes.errorStyle, classes.width380)}>
                      {errors.unit_count}
                    </div>
                  )}
                </div>
              </Grid>

              <Grid
                item
                md={3}
                xs={12}
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <RoundButton
                  type="submit"
                  onClick={handleSubmit}
                  disabled={
                    !values.hash_id ||
                    isSubmitting ||
                    Object.keys(errors).length > 0
                  }
                  className={
                    !values.hash_id ||
                    isSubmitting ||
                    Object.keys(errors).length > 0
                      ? classes.disabledsubmitButton
                      : classes.submit
                  }
                >
                  ثبت حمایت
                </RoundButton>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.gridFullWidthItemStyle}>
                  <label
                    htmlFor="description"
                    className={clsx(classes.labelStyle, classes.width92)}
                  >
                    توضیحات
                    <Image
                      src={requerd}
                      alt="requerd"
                      width={8}
                      height={8}
                      blurDataURL={requerd}
                    />
                  </label>
                  <TextareaAutosize
                    minRows={5}
                    name="description"
                    placeholder="درصورت تمایل اطلاعات تکمیلی تراکنش خود را درج کنید"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.description}
                    className={clsx(classes.inputStyle, classes.width92)}
                  />
                  {errors.description && touched.description && (
                    <div className={clsx(classes.errorStyle, classes.width92)}>
                      {errors.description}
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default PaymentForm;
